import { render } from "./Addemailcampaign.vue?vue&type=template&id=684dd184"
import script from "./Addemailcampaign.vue?vue&type=script&lang=js"
export * from "./Addemailcampaign.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__